//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import uploadOrderFile from "./components/uploadOrderFile";
export default {
  name: "orderTracking",
  components: {
    uploadOrderFile: uploadOrderFile
  },
  mixins: [tabulation],
  data: function data() {
    return {};
  },
  created: function created() {},
  methods: {}
};